export default {"src":"/_next/static/media/LBTYK.ac6b48e7.svg","height":18,"width":18};